// TODO: add your photos to public/images/apartment/ named 1.jpg, 2.jpg, 3.jpg, ...
// and add/remove entries below to match how many photos you actually have.
export const images = [
	'images/apartment/1.jpg',
	'images/apartment/2.jpg',
	'images/apartment/3.jpg',
	'images/apartment/4.jpg',
	'images/apartment/5.jpg',
	'images/apartment/6.jpg',
	'images/apartment/7.jpg',
	'images/apartment/8.jpg',
	'images/apartment/9.jpg',
	'images/apartment/10.jpg',
];

export const galleryPreview = [
	'images/apartment/1.jpg',
	'images/apartment/2.jpg',
	'images/apartment/3.jpg',
	'images/apartment/4.jpg',
	'images/apartment/5.jpg',
	'images/apartment/6.jpg',
];
